$(document).ready(function() {
  $(".submit-button-event-session").click(function() {
    var status     = $("#radio-button-status input[type='radio']").filter(':checked')
    var is_current = $("#radio-button-is-current input[type='radio']").filter(':checked')
    var text_alert = ''
    var title      = $('#event-session-title').val();
    var condition1 = status.data('status') == 'ended'
    var condition2 = is_current.data('is-current') == 'yes'
    var condition3 = condition1 && condition2

    if (condition3) {
      text_alert = I18n.t('global.notices.are_you_sure') + ` \n - ${title} ` + I18n.t('global.notices.is_the_current_event_session') + ` \n - ` + I18n.t('global.notices.scan_out_all_ticket_sessions')
    } else if (condition2) {
      text_alert = I18n.t('global.notices.are_you_sure') + ` \n - ${title} ` + I18n.t('global.notices.is_the_current_event_session')
    } else if (condition1) {
      text_alert = I18n.t('global.notices.are_you_sure') + ` \n - ` + I18n.t('global.notices.scan_out_all_ticket_sessions')
    } else {
      return true
    }

    if (confirm(text_alert)) {
      return true
    } else {
      return false
    }
  });
})
